import {submitChangeRequestActionApi} from '../../services/nmbs-users-api';
import {fetchRemarksOptionsApi, downloadCashRegisterApi, fetchMetaDataApi, fetchChangeRequestOverviewApi} from '../../services/common-api';

export const fetchChangeRequestOverview = (bpCode) => {
    return fetchChangeRequestOverviewApi(bpCode);
}

export const submitChangeRequestAction = (changeRequestNumber, remarks, actionId, modifiedBy) => {
    return submitChangeRequestActionApi(changeRequestNumber, remarks, actionId, modifiedBy);
}

export const fetchMetaData = () => {
    return fetchMetaDataApi(2);
}

export const fetchRemarksOptions = () => {
    return fetchRemarksOptionsApi();
}

export const downloadIntakeBook = (contractCode, revenueDate, isRevisedFile) => {
    return downloadCashRegisterApi(contractCode, revenueDate, isRevisedFile);
}




